// Explicit initial rollout. Other UFs/products keep their existing validation UI.
// Expand only together with the authorized schema/data migration.
export function usarValidacaoSelo(uf) {
  return !!(uf && (uf.isSala || uf.isParceiro) && ["selo-pa-hlg", "selo-sala-pa", "selo-rj-hlg", "selo-sala-rj"].includes(uf.banco));
}
